<template>
  <span>
    <edit-property-permissions-list
      v-if="(editable && isEditingPermissions)"
      @cancel="isEditingPermissions = false"
      @save-success="isEditingPermissions = false"
    />
    <property-settings-list
      v-else
      :editable="editable"
      :user-id="userId"
      has-filters
      @toggle-edit-permissions="isEditingPermissions = true"
    />
  </span>
</template>

<script>
  import PropertySettingsList from './PropertySettingsList'
  import EditPropertyPermissionsList from './EditPropertyPermissionsList'

  export default {
    name: 'PropertySettings',
    components: { PropertySettingsList, EditPropertyPermissionsList },
    props: {
      userId: [Number, String],
      editable: Boolean,
      defaultPropertySettings: Object,
    },
    data () {
      return {
        isEditingPermissions: false,
      }
    },
    created () {
      if (this.$route.query.edit) this.isEditingPermissions = true
    },
  }
</script>
